<template>
  <div class="home">
    <div class="home-head">
      <header-comp :ruleShow="ruleShow" @changeRuleState="changeRuleState"></header-comp>
    </div>
    <div v-if="isShowVideo">
      <!-- 视频 -->
      <div
        class="home-head-video"
        :class="[{ 'head-h5': !isApp }]"
      >
        <video-comp></video-comp>
      </div>
      <!-- 权益 -->
      <div class="home-rights">
        <rights-comp :rightsList="rightsList" :isLogin="isLogin" @gotoLogin="gotoLogin"/>
      </div>
      <!-- 领课按钮 -->
      <div class="home-btn" @click.stop="handleCourse">
        <div class="home-hand"><Lottie :options="lottieOptionsHand" :width="86" :height="94"/></div>
        <div class="home-btn-wrap">
          <div class="home-btn-warp-text" v-if="!offline">
            <div class="home-btn-warp-text-desc">领课解锁权益</div>
            <div class="home-btn-warp-text-detail" v-if="num >= 10000">已有{{ num }}人报名</div>
          </div>
           <div class="home-btn-warp-text" v-else>
            <div class="home-btn-warp-text-desc">{{isLogin ? '活动已结束' : '报名夏令营'}}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 转盘区域 -->
    <div class="home-lottery" v-if="isShowLottery" :class="[{ 'lottery-app': isApp }]">
      <lottery-comp :userId="userId" :isAward="isAward" :isShenhe="isShenhe" :offline="offline"></lottery-comp>
    </div>
    <div v-if="isShowLottery">
      <Main/>
    </div>

    <!-- 登录注册弹框 -->
    <van-popup v-model="loginShow" class="x-van-popup">
      <xes-tal-login
        :loginData="loginData"
        @loginSuccess="loginSuccess"
        @regSuccess="regSuccess"
        @close="loginShow = false"
      />
    </van-popup>
    <!-- 活动规则弹窗 -->
    <van-popup v-model="ruleShow" round class="rule-van-popup">
      <div class="rule-wrapper">
        <div class="close" @click="ruleShow = false"></div>
        <div class="rule-title"></div>
        <rule-comp />
      </div>
    </van-popup>
    <!-- 分享全局弹窗 -->
    <van-popup v-model="shareShow" round class="share-van-popup">
      <div class="sharecall" :class="[{ label2sharecall: dialogData.type === 2 }]">
        <div class="close" @click="shareShow = false"></div>
        <div class="headimg" v-if="dialogData.label === 1"></div>
        <p class="title">{{ dialogData.title }}</p>
        <p class="desc">{{ dialogData.desc }}</p>
        <button class="goUpload" @click="handleUpload">{{ dialogData.btndesc }}</button>
      </div>
    </van-popup>
    <wanliu :type="type" ref="wanliu"/>
    <div v-if="!GlobalShow && offline">
      <offLineDialog ref="dialog" :type="dialogType"/>
    </div>

  </div>
</template>

<script>
// import checkLogin from '@mixin/checkLogin'
import { XesTalLogin } from '@xes/terra'
import { isApp, getUrlParmas } from '@/common/utils/xesFunction.js'

import videoComp from '../components/videoComp'
import header from '../components/header'
import Lottery from '../components/Lottery/index.vue'
import rule from '../components/rule'
import rights from '../components/rights'
import Lottie from '../components/lottie2'
import { mapActions, mapState } from 'vuex'
import { XIECHENG, SHARE, RIGHTLIST, XCRIGHTLIST, GETCOURSE, SOURCEID } from '../const'
// import resolveUrl from '@/common/utils/resolveUrl'
import { dailyStorge, isOffline } from '../utils'
import animationData from '../assets/lottie/guide.json'
import wanliu from '../components/wanliu.vue'
import offLineDialog from '../components/offLineDialog.vue'
import Main from '../components/main.vue'

export default {
  name: 'Home',
  components: {
    'xes-tal-login': XesTalLogin,
    'video-comp': videoComp,
    'header-comp': header,
    'lottery-comp': Lottery,
    'rule-comp': rule,
    'rights-comp': rights,
    Lottie,
    wanliu,
    Main,
    offLineDialog
  },
  data() {
    return {
      isLogin: false, // 是否有登录态
      loginShow: false, // 登录弹框出现
      shareShow: false, //
      isApp: isApp(), // 是否app,
      apply: false, // 用户是否报名征文大赛
      loginData: {
        sGroupId: this.$config.sGroupId,
        source_id: ''
      }, // 登录所需参数
      isAward: false, // 是否领课
      isCharged: false, // 是否已兑换
      num: 0,
      ruleShow: false, // 规则弹窗
      dialogData: {
        title: '',
        desc: '',
        btndesc: '',
        type: '',
        label: ''
      },
      rightsList: RIGHTLIST,
      xcrightsList: XCRIGHTLIST,
      userId: '',
      sourceId: SOURCEID,
      lottieOptionsHand: {
        loop: true,
        autoplay: true,
        animationData: animationData
      }, // 动画配置
      type: -1, // 弹窗类型
      offline: isOffline(),
      dialogType: -1,
      isShenhe: false,
      GlobalShow: false
    }
  },
  watch: {
    // async isLogin(val) {
    //   if (val) {
    //     const res = await this.getDrawNum({
    //       userId: this.userId || this.$xesCookie.get('stu_id')
    //     })
    //     this.$store.commit('setDrawNum', res.currentNum)
    //   }
    // },
    userId(val) {
      console.log('watchuserid', val)
      if (val) {
        console.log('watchuseridif', val)
        this.userId = val
      }
    }
  },
  computed: {
    ...mapState(['sGroupId', 'phoneNum', 'drawNum']),
    isShowVideo() {
      const resp = (this.isLogin && !this.isAward) || !this.isLogin
      return resp
    },
    isShowLottery() {
      return this.isLogin && this.isAward
    }
  },

  created() {
    this.init()
    this.loginData.source_id = SOURCEID
    window.addEventListener('pageshow', function(event) {
      if (event.persisted) { // ios 有效, android 和 pc 每次都是 false
        location.reload()
      }
    })
  },
  async mounted() {
    window.wxAppLeftButtonClick = this.leftbtnFn
    const resp = await this.$api.getOffline()
    const { code, data } = resp
    if (code === 0) {
      this.offline = isOffline(data.endTime, data.curTime)
    }
  },

  methods: {
    ...mapActions(['getDrawNum']),
    leftbtnFn() {
      // 处理逻辑
      if (this.isLogin) {
        if (!this.isAward) {
          this.type = 0
        } else if (this.drawNum > 0) {
          this.type = 1
        }
        if (this.type === -1) {
          return false
        }

        if (localStorage.getItem(`summercampLotteryDialog${this.type}`) !== JSON.stringify(this.type)) {
          localStorage.setItem(`summercampLotteryDialog${this.type}`, JSON.stringify(this.type))
          this.$refs.wanliu.wanliu = true
          return true
        }
      }
    },
    handleUpload() {
      if (this.dialogData.type === 1) {
        // 上传
        const tal_token = this.$xesCookie.get('tal_token')
        const URL = `${SHARE}?sourceId=${SOURCEID}&tal_token=${tal_token}&titleBarType=2`
        window.location.href = URL
      }
      this.shareShow = false
    },
    changeRuleState(flag) {
      this.ruleShow = flag
    },
    // 兑换携程权益
    async handleCharge() {
      this.$xesLogger.clickMsg({
        params: {
          clickid: 12,
          action: 'click',
          elemname: '点击领取携程权益'
        }
      })

      const url = `${XIECHENG}&legaophone=${this.phoneNum || ''}`
      const _url =
        'https://contents.ctrip.com/activitysetupapp/mkt/index/tal123?allianceid=3192568&sid=6497424'
      setTimeout(() => {
        window.location.href = this.isApp ? _url : url
      }, 300)
    },
    async init() {
      console.log('home init')
      await this.checkLogin(false)

      // if (res.code === 11025) {
      //   this.isLogin = false
      //   return
      // }
      console.log(this.isLogin, '登录')
      if (!this.isLogin) {
        return
      }
      // this.userId = res.data.userId || this.$xesCookie.get('stu_id')
      // this.isLogin = true
      // 新用户绑定关系
      // 判断是否是新用户 && 判断来源
      const { isNew, sumCamp, scene } = getUrlParmas(location.href) || {}
      const sceneStr = decodeURIComponent(scene)
      const sceneQuery = {}
      sceneStr.split('&').forEach(item => {
        const kv = item.split('=')
        sceneQuery[kv[0]] = kv[1]
      })

      if (sumCamp === '1' && isNew === '1') {
        this.$xesLogger.clickMsg({
          params: {
            clickid: 36,
            action: 'click',
            elemname: '新用户进入'
          }
        })
        // this.bindRelation(sceneQuery.i)
      }
      this.getPageData()
    },
    async bindRelation(id) {
      try {
        const res = await this.$api.getDynamicParam({
          id
        })

        if (res.code === 0) {
          const { sGroupId, userId } = res.data || {}
          await this.$api.getRelated({
            relateId: userId,
            sGroupId: sGroupId,
            relateTypeCode: 'REGISTER'
          })
        }
      } catch (e) {}
    },
    /**
     * 获取页面数据
     */
    async getPageData() {
      if (!this.isLogin) {
        return
      }
      // 获取弹窗数据
      await this.GlobalDialog()

      const sourceInfo = await this.$api.getCourseInfo({
        userId: this.userId || this.$xesCookie.get('stu_id'),
        sGroupId: this.sGroupId
      })
      if (sourceInfo.code === 0) {
        // 判断是否标记领课
        try {
          const resp = await this.$api.getMark({
            sGroupId: this.sGroupId,
            markType: 'getCourse'
          })
          const { code, data = {} } = resp || {}
          if (code === 0) {
            if (data.info && data.info.mark) {
              this.isAward = true
              // 已经标记领课，2 抽奖次树
              const resDraw = await this.getDrawNum({
                userId: this.userId
              })
              this.$store.commit('setDrawNum', resDraw.currentNum)
              this.$store.commit('setLotteryNum', resDraw.usdNum)
              const result = await this.$api.getShenhe({
                sGroupId: this.sGroupId
              })

              if (result.code === 0) {
                const { count } = result.data || {}
                this.isShenhe = count > 0
                if (count > 0) {
                  this.dialogType = 3
                } else if (resDraw.currentNum === 0) {
                  this.dialogType = 2
                } else {
                  this.dialogType = 1
                }
                this.$refs.dialog.offLine = true
              }
            } else {
              this.isAward = false
              this.dialogType = 0
              this.$refs.dialog.offLine = true
            }
          } else {
            this.isAward = false
            this.dialogType = 0
            this.$refs.dialog.offLine = true
          }
          // 获取征文信息
          // this.getZWInfo()
        } catch (e) {
          // this.isAward = false
        }
      }
    },
    // 获取征文信息
    async getZWInfo() {
      try {
        const resp = await this.$api.getZWInfo()
        const { code, data = {} } = resp || {}
        if (code === 0) {
          if (data.apply_status === 1) {
            this.apply = true
          } else {
            this.apply = false
          }
        }
      } catch (e) {}
    },
    // 弹窗信息
    async GlobalDialog() {
      try {
        const { code, data } = await this.$api.getUploadStatus({
          sGroupId: this.sGroupId
        })
        this.$xesLogger.clickMsg({
          params: {
            clickid: 100,
            action: 'click',
            elemname: '弹窗接口埋点',
            resultCode: code,
            resultData: data
          }
        })
        if (code === 0) {
          // 1 分享
          // 2 upload
          // 3 审核成功
          // 4 审核失败
          const uid = this.userId || this.$xesCookie.get('stu_id')
          if (data.status === 1) {
            // if (dailyStorge(`${uid}share`)) {
            //   this.dialogData = {
            //     title: '分享海报成功',
            //     desc: '请至少在朋友圈保留2小时后上传截图',
            //     btndesc: '我知道了',
            //     type: 2,
            //     label: 1
            //   }
            //   this.shareShow = true
            // }
          } else if (data.status === 2) {
            // if (dailyStorge(`${uid}upload`)) {
            //   this.dialogData = {
            //     title: '上传时间到啦',
            //     desc: '去上传截图才能领取赢得抽奖机会哦～',
            //     btndesc: '去上传',
            //     type: 1,
            //     label: 1
            //   }
            //   this.shareShow = true
            // }
          } else if (data.status === 3) {
            if (dailyStorge(`${uid}shsuccess`)) {
              this.dialogData = {
                title: '恭喜您！',
                desc: '截图审核通过，获取1次抽奖机会',
                btndesc: '我知道了',
                type: 2,
                label: 2
              }
              this.shareShow = true
              this.GlobalShow = true
            }
          } else if (data.status === 4) {
            console.log('share', status)
            if (dailyStorge(`${uid}shfailure`)) {
              this.dialogData = {
                title: '很抱歉',
                desc: '您的截图审核未通过，请注意上传规范',
                btndesc: '我知道了',
                type: 2,
                label: 2
              }
              this.shareShow = true
              this.GlobalShow = true
            }
          }
        }
      } catch (e) {}
    },
    // 用户登录后操作
    loginFn() {
      this.getPageData()
    },
    async handleCourse() {
      this.$xesLogger.clickMsg({
        params: {
          clickid: 10,
          action: 'click',
          elemname: '领课按钮点击'
        }
      })
      if (this.isLogin) {
        if (this.offline) {
          this.$toast('活动已结束')
          return
        }
        // 领取课程  渠道号
        const { channelId = '' } = this.$route.query || {}
        window.location.href = `${GETCOURSE}&sourceId=${SOURCEID}&channelId=${channelId}`
      } else {
        await this.checkLogin(true)
      }
    },
    async gotoLogin() {
      await this.checkLogin(true)
    },
    // 检测登陆态
    async checkLogin(isAutoLogin) {
      if (this.isLogin) {
        // this.loginCallback()
        return
      }
      await this.$api.checkLogin().then(res => {
        if (res.code === 11025) {
          if (this.isApp) {
            this.appLogin(isAutoLogin)
          } else {
            if (isAutoLogin) {
              this.loginShow = true
            }
            this.isLogin = false
          }
        } else {
          this.isLogin = true
          this.setUserId(res.userId)
          // this.loginCallback()
        }
      })
      return this.isLogin
    },

    appLogin(isAutoLogin, next) {
      xesApp.appLoginBack = result => {
        if (+result === 1) {
          const isAndroid =
            navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1
          next && next()
          if (isAndroid) {
            window.location.reload()
          }
        }
      }
      if (isAutoLogin) {
        xesApp.xesLogin('xesApp.appLoginBack')
      }
    },
    setUserId(userId) {
      this.$store.commit('SET_USERID', userId)
      this.$xesLogger.setCommonParam({
        userid: userId
      })
    },

    // 新用户注册成功
    async regSuccess(data) {
      this.setUserId((data.user_info && data.user_info.user_id) || '')
      this.loginShow = false
      this.isLogin = true
      this.loginFn()
    },
    // 老用户登录成功
    async loginSuccess(data) {
      this.setUserId((data.user_info && data.user_info.user_id) || '')
      this.loginShow = false
      this.isLogin = true
      this.loginFn()
    }
  }
}
</script>
<style lang="less">
.home {
  width: 100%;
  background: #f8d484;
  // background-image: linear-gradient(#9fe0c2, #f8d484);

  .rule-van-popup,
  .share-van-popup {
    overflow-y: unset !important;
  }

  .zw-entry {
    position: relative;
    height: 582px/2;
    overflow: hidden;
    font-weight: bold;
    background: url('../assets/images/zw-bg.png') no-repeat;
    background-size: cover;

    .zw-wrap {
      padding: 136px/2 90px/2 0 85px/2;
      font-size: 12px;
      color: #a6662e;

      .zw-desc {
        margin-top: 13px;
      }

      .zw-img {
        width: 100%;
        height: 154px/2;
        margin: 0 auto;
        background: url(../assets/images/zw-banner.png) no-repeat;
        background-size: cover;
        border-radius: 10px;
      }

      .zw-btn {
        width: 342px/2;
        height: 88px/2;
        margin: 13px auto;
        font-size: 17px;
        font-weight: bold;
        line-height: 80px/2;
        text-align: center;
        color: #fff;
        background: url(../assets/images/btn-desc.png) no-repeat;
        background-size: 100% auto;
      }
    }
  }

  .xz-entry {
    background-image: url('../assets/images/write-bg.png') !important;

    .zw-img {
      background-image: url(../assets/images/write-banner.png) !important;
    }
  }

  .xc-entry {
    position: relative;
    height: 622px/2;
    margin: 8px auto 0;
    overflow: hidden;
    background: url('../assets/images/ribg.png') no-repeat;
    background-size: cover;

    .xc-wrap {
      display: flex;
      margin: 0 auto;
      margin: 132px/2 42px 0 40px;

      .xclist {
        flex: 1;
        text-align: center;

        .xcimg {
          width: 150px/2;
          height: 150px/2;
          margin: 0 auto;
          background: #ccc;
        }

        .img0 {
          background: url(../assets/images/ri0.png) no-repeat;
          background-size: cover;
        }

        .img1 {
          background: url(../assets/images/ri1.png) no-repeat;
          background-size: cover;
        }

        .img2 {
          background: url(../assets/images/ri2.png) no-repeat;
          background-size: cover;
        }

        .title {
          // padding: 0 10px;
          margin-top: 27px/2;
          font-size: 13px;
          font-weight: bold;
          font-family: FZPinShangHeiS-DB-GB;
          color: #a6662e;
        }

        .desc {
          font-size: 13px;
          font-weight: bold;
          font-family: FZPinShangHeiS-DB-GB;
          color: #a6662e;
        }
      }
    }

    .xc-btn {
      width: 342px/2;
      height: 88px/2;
      margin: 13px auto 8px;
      font-size: 17px;
      font-weight: bold;
      line-height: 80px/2;
      text-align: center;
      color: #fff;
      background: url(../assets/images/btn-desc.png) no-repeat;
      background-size: 100% auto;
    }

    .xc-rule {
      font-size: 11px;
      text-align: center;
      color: #acacac;
    }
  }

  &-head-video {
    position: relative;
    height: 435px/2;
    margin: 0 11px/2;
    margin-top: -60px;
    overflow: hidden;
    background: url('../assets/images/video-bg.png') no-repeat;
    background-size: cover;
  }

  .head-h5 {
    margin-top: -59px;
  }

  &-rights {
    margin-bottom: 159px/2;
  }

  &-lottery {
    position: relative;
    width: 729px/2;
    height: 927px/2;
    margin: 0 5px;
    margin-top: -121px/2;
    background-image: url('../assets/images/bj.png');
    background-size: contain;
    background-repeat: no-repeat;
  }

  .lottery-app {
    margin-top: -115px/2;
  }

  &-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 110;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 159px/2;
    text-align: center;
    background: #fff;
    box-shadow: 0 0 16px 0 rgba(255, 176, 0, 0.59);

    .home-hand {
      position: absolute;
      left: 60%;
      z-index: 111;
    }

    .home-btn-warp-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 684px/2;
      height: 100px/2;
      font-weight: bold;
    }

    .home-btn-warp-text-desc {
      font-size: 36px/2;
      color: #fff;
    }

    .home-btn-warp-text-detail {
      font-size: 10px;
      line-height: 12px;
      color: #ffdcdc;
    }

    &-wrap {
      width: 684px/2;
      height: 110px/2;
      font-weight: bold;
      background: url(../assets/images/btn-bottom.png) no-repeat;
      background-size: 100% auto;
      // animation: breathe 1s linear 500ms infinite alternate;
    }

    @keyframes breathe {
      from {
        transform: scale(1);
      }

      to {
        transform: scale(0.9);
      }
    }
  }

  .rule-wrapper {
    width: 590px/2;
    height: 735px/2;
    // text-align: center;
    padding: 77px/2 35px/2;
    overflow: hidden;
    background: #fff;
    border-radius: 20px/2;

    .rule-title {
      position: absolute;
      top: -23px/2;
      left: 50%;
      width: 340px/2;
      height: 72px/2;
      background: url(../assets/images/rule-tit.png) no-repeat;
      background-size: 100% auto;
      transform: translateX(-50%);
    }
  }

  .label2sharecall {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 188px/2;
  }

  .sharecall {
    width: 590px/2;
    height: 412px/2;
    overflow: hidden;
    text-align: center;
    background: #fff;
    border-radius: 20px/2;

    .headimg {
      width: 68px/2;
      height: 68px/2;
      margin: 27px auto 0;
      background: url('../assets/images/tit-icon.png') no-repeat;
      background-size: cover;
    }

    .title {
      margin-top: 24px/2;
      font-size: 16px;
      font-weight: bold;
      font-family: FZLanTingHeiS-DB-GB;
      line-height: 16px;
      color: #90402c;
    }

    .desc {
      margin-top: 42px/2;
      font-size: 12px;
      font-family: FZLanTingHei-M-GBK;
      line-height: 12px;
      color: #666;
    }

    .goUpload {
      width: 462px/2;
      height: 72px/2;
      margin-top: 46px/2;
      font-size: 30px/2;
      font-weight: 400;
      font-family: FZLanTingHei-M-GBK;
      color: #fff;
      background: linear-gradient(-69deg, #e42225 0%, #ed4351 99%);
      border-radius: 36px/2;
    }
  }

  .close {
    position: absolute;
    top: -13px/2;
    right: -13px/2;
    width: 27px;
    height: 27px;
    background: url('../assets/images/guanbi.png') no-repeat;
    background-size: 100% auto;
  }
}
</style>
